import * as HLF from "html-living-framework";
import {Animation} from "./Animation";
import {BobInAnimation} from "./BobInAnimation";
import {DanceAnimation} from "./DanceAnimation";
import {DropAnimation} from "./DropAnimation";
import {ExcitedAnimation} from "./ExcitedAnimation";
import {FlipAnimation} from "./FlipAnimation";
import {FloatAnimation} from "./FloatAnimation";
import {FloatInAnimation} from "./FloatInAnimation";
import {FollowAnimation} from "./FollowAnimation";
import {FromAnimation} from "./FromAnimation";
import {JumpAnimation} from "./JumpAnimation";
import {PulseAnimation} from "./PulseAnimation";
import {RotateAnimation} from "./RotateAnimation";
import {ScaleUpAnimation} from "./ScaleUpAnimation";
import {SlideInAnimation} from "./SlideInAnimation";
import {StompInAnimation} from "./StompInAnimation";
import {TickleAnimation} from "./TickleAnimation";

export function AnimationFactory(command: string): Animation {
    const params = command.split(/\s+/);
    const type = params.shift();
    let animation: Animation;
    switch (type) {
        case "bobIn":
            animation = new BobInAnimation(params[0] as "left" | "right", params[1] as "quick");
            break;
        case "scaleUp":
            animation = new ScaleUpAnimation();
            break;
        case "squishStretch":
            animation = new ScaleUpAnimation();
            animation.ease = "squishStretch";
            break;
        case "slideIn":
            animation = new SlideInAnimation(params[0] as "up" | "down" | "left" | "right");
            break;
        case "floatIn":
            animation = new FloatInAnimation(params[0] as "left" | "right");
            break;
        case "float":
            animation = new FloatAnimation();
            break;
        case "stompIn":
            animation = new StompInAnimation(params[0] as "left" | "right");
            break;
        case "follow":
            animation = new FollowAnimation(params[0]);
            break;
        case "dance":
            animation = new DanceAnimation();
            break;
        case "tickle":
            animation = new TickleAnimation();
            break;
        case "jump":
            animation = new JumpAnimation();
            break;
        case "excited":
            animation = new ExcitedAnimation();
            break;
        case "drop":
            animation = new DropAnimation();
            break;
        case "flip":
            animation = new FlipAnimation();
            break;
        case "pulse":
            animation = new PulseAnimation();
            break;
        case "from":
            animation = new FromAnimation(params[0], params[1] === "bezier");
            break;
        case "rotate":
            animation = new RotateAnimation(params[0] === "yoyo");
            break;
        default:
            animation = new Animation();
            params.unshift(command);
    }
    for (const param of params) {
        const [name, value] = param.split("=");
        switch (name) {
            case "id":
                animation.id = value;
                break;
            case "delay":
                const [min, max] = (value || "").split("-").map((it) => parseFloat(it));
                if (!isNaN(min) && !isNaN(max)) {
                    animation.delay = HLF.Random.floatBetween(min, max);
                } else {
                    animation.delay = parseFloat(value) || undefined;
                }
                break;
            case "time":
                animation.time = parseFloat(value) || undefined;
                break;
            case "speed":
                animation.speed = parseFloat(value) || undefined;
                break;
            case "repeat":
                animation.repeat = parseFloat(value) || undefined;
                break;
            case "ease":
                animation.ease = value;
                break;
            case "appear":
                animation.appear = true;
                break;
        }
    }
    return animation;
}
